import { makeStyles, Theme } from '@material-ui/core/styles';

type UseSideBarTemplateStylesProps = {
    showCertificateButton: string | boolean;
};

export const useSideBarTemplateStyles = makeStyles<Theme, UseSideBarTemplateStylesProps>(() => ({
    logo: {
        height: 'auto',
        padding: '16px 0 24px 0',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    button: props => ({
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        padding: '0',
    }),
    items: {
        marginTop: 24,
    },
}));
